export default __webpack_public_path__ + "static/media/9 Mobility Flows.db21e36c.webp";